/** YYYY-MM-DD для input[type=date] */
export const formatDateInputValue = (date) => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** dd/mm/yyyy для відображення (значення input type=date: yyyy-mm-dd) */
export const formatDateDisplayFromInput = (isoDate) => {
  if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return '';
  const [y, m, d] = isoDate.split('-');
  return `${d}/${m}/${y}`;
};

/** Сьогодні (YYYY-MM-DD) */
export const dateInputToday = () => formatDateInputValue(new Date());

/** dd.mm.yyyy для відображення */
export const formatDateDisplayDots = (isoDate) => {
  if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return '';
  const [y, m, d] = isoDate.split('-');
  return `${d}.${m}.${y}`;
};

/** Сьогодні мінус N днів */
export const dateInputDaysAgo = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  d.setHours(0, 0, 0, 0);
  return formatDateInputValue(d);
};
